import { render, staticRenderFns } from "./bulk-message.vue?vue&type=template&id=14dcc0a4&scoped=true"
import script from "./bulk-message.vue?vue&type=script&lang=js"
export * from "./bulk-message.vue?vue&type=script&lang=js"
import style0 from "./bulk-message.vue?vue&type=style&index=0&id=14dcc0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dcc0a4",
  null
  
)

export default component.exports